export default {
  pageTitle: 'Заказы',
  detailTitle: 'Заказ',
  empty: 'Заказов не найдено',
  openOrder: 'Открыть заказ',

  columns: {
    orderId: 'ID заказа',
    clientId: 'ID клиента',
    status: 'Статус',
    processState: 'Состояние',
    restaurant: 'Ресторан',
    restaurantAddress: 'Адрес ресторана',
    createdAt: 'Создан',
    updatedAt: 'Обновлён',
    totalAmount: 'Сумма',
    deliveryFee: 'Доставка',
    paymentMethod: 'Тип оплаты',
    promoCode: 'Промокод',
    promoCodeId: 'ID промокода',
    discountVnd: 'Скидка',
    client: 'Клиент',
    clientName: 'Имя клиента',
    clientPhone: 'Телефон',
    utm_source: 'utm_source',
    utm_medium: 'utm_medium',
    utm_campaign: 'utm_campaign',
    utm_content: 'utm_content',
    utm_term: 'utm_term',
    deliveryAddress: 'Адрес',
    location: 'Координаты',
    itemsSummary: 'Состав',
    courier: 'Курьер',
    courierId: 'ID курьера',
    details: 'Подробно',
  },

  paymentMethods: {
    online: 'Онлайн',
    cash_on_delivery: 'Наличные',
  },

  processState: {
    created: {
      title: 'Создан',
      description: 'клиент создал заказ, но еще не платил',
    },
    paid: {
      title: 'Оплачен',
      description: 'клиент оплатил заказ, значит ресторан должен его принять',
    },
    preparing: {
      title: 'Готовится',
      description: 'ресторан принял заказ, выставил примерное время готовки',
    },
    readyForPickup: {
      title: 'Готов к выдаче',
      description: 'ресторан приготовил блюдо, ждем курьера',
    },
    courierAssigned: {
      title: 'Курьер назначен',
      description: 'админ назначил курьера',
    },
    pickedUp: {
      title: 'Забран (В доставке)',
      description: 'курьер доставляет заказ',
    },
    completed: {
      title: 'Завершен',
      description: 'успешное завершение заказа',
    },
    cancelled: {
      title: 'Отменен',
      description: 'клиент или админ отменил заказ',
    },
  },

  filters: {
    title: 'Фильтры',
    orderId: 'ID заказа',
    orderIdPlaceholder: 'ID заказа',
    clientId: 'ID клиента',
    clientIdPlaceholder: 'ID пользователя',
    restaurant: 'Ресторан',
    restaurantAll: 'Все рестораны',
    status: 'Статус',
    statusAll: 'Все статусы',
    apply: 'Применить',
    reset: 'Сбросить',
  },

  itemsSummary: {
    count: '{count} поз.',
    empty: '—',
  },

  pagination: {
    rowsPerPage: 'Строк на странице',
    of: 'из',
  },

  actions: {
    openDetails: 'Подробнее',
    openDetailsNewWindow: 'Открыть подробнее в новом окне',
    copyId: 'Скопировать ID',
    copyIdSuccess: 'ID скопирован',
    copyIdFailed: 'Не удалось скопировать ID',
    copyValue: 'Скопировать',
    copyValueSuccess: 'Скопировано',
    copyValueFailed: 'Не удалось скопировать',
    openClient: 'Открыть клиента',
    openRestaurant: 'Открыть ресторан',
    openWhatsapp: 'WhatsApp',
    openTelegram: 'Telegram',
    openSendpulse: 'SendPulse',
    restaurantTelegram: 'Telegram-чат',
    acceptRestaurant: 'Принять рестораном',
    acceptCourier: 'Принять курьером',
    confirmClient: 'Подтвердить клиентом',
    accepting: 'Сохранение…',
    confirm: 'Подтвердить действие',
    open: 'Открыть',
  },

  status: {
    completed: 'Завершён',
    new: 'Новый',
    preparing: 'Готовится',
    readyForPickup: 'Готов к выдаче',
    courierAssigned: 'Курьер назначен',
    pickedUp: 'У курьера',
    onTheWay: 'В доставке',
    delivered: 'Доставлен',
    cancelled: 'Отменён',
    cancelled: 'Отменён',
    unknown: 'Неизвестный',
  },

  fields: {
    utm: 'UTM'
  },

  backendStatus: {
    CREATED: 'Создан',
    PAYMENT_PENDING: 'Ожидает оплаты',
    PAID: 'Оплачен',
    ACCEPTED_BY_KITCHEN: 'Принят кухней',
    COOKING: 'Готовится',
    READY: 'Готов к выдаче',
    DISPATCHING: 'Отправляется',
    COURIER_ASSIGNED: 'Курьер назначен',
    PICKED_UP: 'Забран',
    DELIVERED: 'Доставлен',
    COMPLETED: 'Завершен',
    CANCELLED: 'Отменен',
  },

  errors: {
    loadList: 'Не удалось загрузить заказы',
    loadOrder: 'Не удалось загрузить заказ',
    actionFailed: 'Не удалось выполнить действие',
  },

  validation: {
    orderIdInvalid: 'Введите корректный ID заказа',
    clientIdInvalid: 'Введите корректный ID клиента',
    restaurantIdInvalid: 'Введите корректный ID ресторана',
    requiredField: 'Заполните обязательное поле',
  },

  apiErrors: {
    generic: 'Не удалось выполнить запрос. Попробуйте снова.',
    order_not_found: 'Заказ не найден',
    validation_error: 'Проверьте параметры запроса',
    unauthorized: 'Нужна авторизация',
    forbidden: 'Нет доступа',
  },
}
